import React from 'react';
import BaseIcon from './BaseIcon';

interface YoutubeIconProps {
  className?: string;
}

const YoutubeIcon: React.FC<YoutubeIconProps> = ({ className }) => (
  <BaseIcon className={className}>
    <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0 2 2 0 0 1 1.4 1.4 24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0 2 2 0 0 1-1.4-1.4z"></path>
    <path d="m10 15 5-3-5-3z"></path>
  </BaseIcon>
);

export default YoutubeIcon;
